import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { apiPublicInit } from "./api/public";
import { updateUserSettings, clearUserSettings } from "./store/user";
import { updateMetadata, clearMetadata } from "./store/seasons";
import { updateShop, clearShop } from "./store/shop";
import { auth } from "./helpers/firebase";

import Home from "./pages/site/Home";
import Team from "./pages/site/Team";
import MainAppBar from "./components/layout/navigation/MainAppBar";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography, useTheme } from "@mui/material";
import About from "./pages/site/About";
import Games from "./pages/site/Games";
// import Shop from "./pages/site/Shop";
import Login from "./pages/user/Login";
import Register from "./pages/user/Register";
import VerifyEmail from "./pages/user/VerifyEmail";
import ForgotPassword from "./pages/user/ForgotPassword";
import ResetPassword from "./pages/user/ResetPassword";
import MbwayPayment from "./pages/payment/MbwayPayment";
import Logout from "./pages/user/Logout";
import Membership from "./pages/member/Membership";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditMember from "./pages/member/EditMember";
import TermsAndConditions from "./pages/legal/TermsAndConditions";
import CookieAlert from "./components/layout/container/CookieAlert";
import ExternalMember from "./pages/member/ExternalMember";
import ExternalSubmit from "./pages/member/ExternalSubmit";

const App = () => {

    const theme = useTheme();
    const [userAuthResponse, setUserAuthResponse] = React.useState(false);
    const [shrink, setShrink] = React.useState(false);

    const dispatch = useDispatch();

    useEffect(() => {

        let unsubscribeFromAuth = async () => {

            onAuthStateChanged(auth, (user) => {

                setUserAuthResponse(false);

                apiPublicInit((data, successFlag) => {
                    if (successFlag > 0) {
                        if (user && user.emailVerified) {
                            const { uid, displayName, email } = user;
                            dispatch(updateUserSettings({
                                uid,
                                displayName,
                                email,
                                people: data.people ?? [], // NOTE: do not use cart items and orders here
                                isAdmin: data.isAdmin ?? false,
                            }));

                            const orders = Boolean(data.people) && data.people.length > 0 ? data.people.reduce((acc, person) => {
                                acc[person.id] = person.shopOrders;
                                return acc;
                            }, {}) : {};
                            const cart = Boolean(data.people) && data.people.length > 0 ? data.people.reduce((acc, person) => {
                                acc[person.id] = person.cartItems.map(item => {
                                    return {
                                        amount: item.shopOrder.amount,
                                        details: item.shopOrder.details,
                                        id: item.shopOrder.id,
                                        productId: item.shopOrder.productId,
                                        size: item.shopOrder.size,
                                        personId: person.id,
                                    }
                                });
                                return acc;
                            }, {}) : {};

                            dispatch(updateShop({
                                products: data.products,
                                orders: orders,
                                cart: cart,
                            }));
                        }
                        else {
                            dispatch(clearUserSettings());
                            dispatch(updateShop({
                                products: data.products,
                                orders: {},
                                cart: {},
                            }));
                            auth.signOut();
                        }

                        dispatch(updateMetadata({
                            seasons: data.seasons,
                            seasonToCheck: data.seasonToCheck,
                            latestGames: data.latestGames,
                            nextGames: data.nextGames,
                        }));

                    } else {
                        dispatch(clearUserSettings());
                        dispatch(clearMetadata());
                        dispatch(clearShop());
                    }
                    setUserAuthResponse(true);
                });
            });

            return () => { unsubscribeFromAuth() };
        };

        unsubscribeFromAuth();

    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 100) {
                setShrink(true);
            } else {
                setShrink(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <Box>
            {
                userAuthResponse ? (
                    <BrowserRouter>
                        <MainAppBar shrink={shrink} />
                        <CookieAlert />
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/games" element={<Games />} />
                            <Route path="/team" element={<Team />} />
                            {/* <Route path="/shop" element={<Shop />} /> */}
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                            <Route path="/verify-email" element={<VerifyEmail />} />
                            <Route path="/forgot-password" element={<ForgotPassword />} />
                            <Route path="/reset-password" element={<ResetPassword />} />
                            <Route path="/mbway/:paymentReferenceId" element={<MbwayPayment />} />
                            <Route path="/logout" element={<Logout />} />
                            <Route path="/membership" element={<Membership />} />
                            <Route path="/edit-member/:topic/:id" element={<EditMember />} />
                            <Route path="/privacy" element={<PrivacyPolicy />} />
                            <Route path="/terms" element={<TermsAndConditions />} />
                            <Route path="/external-member" element={<ExternalMember />} />
                            <Route path="/external-submit" element={<ExternalSubmit />} />
                        </Routes>
                    </BrowserRouter>
                ) : (
                    <Box>
                        <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
                            <Box textAlign="center">
                            <img src={`${process.env.PUBLIC_URL}/logo512.png`} alt="logo" width="100px" />
                            <Typography>
                                Estamos a carregar a informação. Por favor, aguarde...
                            </Typography>
                            </Box>
                        </Box>
                    </Box>
                )
            }
            <ToastContainer
                position="bottom-left"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={true}
                rtl={false}
                draggable={true}
                pauseOnHover={true}>
            </ToastContainer>
        </Box>
    );
}

export default App;
